import { defaultTheme } from '@yes.technology/react-toolkit'
import { StyledCollapsibleCard } from './GroupControls.styles'
import type { GroupControlsViewProps } from './GroupControlsView.types'

const GroupControlsView = ({
  leftHeaderElement,
  centerHeaderElement,
  rightHeaderElement,
  children,
  hideFieldsCollapsibleContainer,
  collapsibleCardRef,
  areaLineProps,
  iconColor,
  defaultOpenState = true
}: GroupControlsViewProps) => {
  const dropdownIconColor = iconColor ?? defaultTheme.colors.blackText

  if (hideFieldsCollapsibleContainer) {
    return <>{children}</>
  }

  return (
    <StyledCollapsibleCard
      data-testid='group-controls'
      leftHeaderElement={leftHeaderElement}
      centerHeaderElement={centerHeaderElement}
      rightHeaderElement={rightHeaderElement}
      heightClass='small'
      headerColor='gray'
      alignSecondPosition='center'
      ref={collapsibleCardRef}
      defaultOpenState={defaultOpenState}
      wrapRightAreaElement
      flexRightAreaElement
      areaLineProps={areaLineProps}
      iconColor={dropdownIconColor}
    >
      {children}
    </StyledCollapsibleCard>
  )
}

export default GroupControlsView
